<script lang="ts">
  import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
  import { IOrderEmailSettings } from '../../../interfaces/IOrderEmailSettings';

  @Component
  export default class OrderEmailSettingsAuth extends Vue {
    @Prop() settings: IOrderEmailSettings;
    @Prop() value: boolean;
    valid = false;

    async created() {}

    @Watch('valid', { immediate: true })
    onValidChange(newVal: boolean) {
      this.$emit('input', newVal);
    }
  }
</script>

<template>
  <v-form @submit.prevent v-model="valid">
    <v-row>
      <v-col cols="12" sm="6">
        <v-text-field
          label="Host"
          outlined
          dense
          v-model="settings.auth.host"
          :rules="$rule('required')"
        />
      </v-col>
      <v-col cols="12" sm="6">
        <v-text-field
          label="Puerto"
          type="number"
          outlined
          dense
          v-model="settings.auth.port"
          :rules="$rule('required|number')"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6">
        <v-text-field
          label="Usuario / Cuenta de correo"
          outlined
          autocomplete="username"
          dense
          v-model="settings.auth.user"
          :rules="$rule('required')"
        />
      </v-col>
      <v-col cols="12" sm="6">
        <v-text-field
          label="Contraseña"
          type="password"
          autocomplete="new-password"
          outlined
          dense
          v-model="settings.auth.pw"
          :rules="$rule('required')"
        />
      </v-col>
    </v-row>
  </v-form @submit.prevent>
</template>

<style scoped lang="scss"></style>
